import { render, staticRenderFns } from "./Part3.vue?vue&type=template&id=07adfcc8&scoped=true"
import script from "./Part3.vue?vue&type=script&lang=js"
export * from "./Part3.vue?vue&type=script&lang=js"
import style0 from "./Part3.vue?vue&type=style&index=0&id=07adfcc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07adfcc8",
  null
  
)

export default component.exports